import React, { createContext, useContext, useState, useCallback } from 'react';

const JobAlertContext = createContext(null);

export const JobAlertProvider = ({
    children,
    searchCondition,
    conditionString,
    isFromPaidJob,
    isDoubleOptIn,
}) => {
    const [jobAlertResult, setJobAlertResult] = useState({
        result: '', // success, error, failure
        message: '',
    });

    const updateJobAlertResult = ({result, message}) => setJobAlertResult({
        result,
        message,
    });

    // ジョブアラートの登録結果が成功したかどうかを判定
    const isJobAlertSubmitSuccess = jobAlertResult.result === 'success';

    const value = {
        searchCondition,
        conditionString,
        jobAlertResult,
        updateJobAlertResult,
        isFromPaidJob,
        isDoubleOptIn,
        isJobAlertSubmitSuccess
    };

    return (
        <JobAlertContext.Provider value={value}>
            {children}
        </JobAlertContext.Provider>
    );
};

export const useJobAlert = () => {
    const context = useContext(JobAlertContext);
    if (!context) {
        throw new Error('useJobAlert must be used within a JobAlertProvider');
    }
    return context;
};
